import customAxios from "../../customAxios";
import {DELETE_SUPER_AGENT} from "../../routes";

const deleteSuperAgent = async (userId: string) => {
  try {
    return (await customAxios.delete(DELETE_SUPER_AGENT + `/${userId}`)).data;
  } catch (error: any) {
    console.log({DELETE_SUPER_AGENT: error});
    return false;
  }
};

export default deleteSuperAgent;
